import { SidebarTrigger, useSidebar } from '@frontend/components/ui/sidebar';
import { cn } from '@frontend/lib/utils';
import { Menu } from 'lucide-react';

export function AppHamburgerButton() {
  const { open, isMobile } = useSidebar();

  return (
    <div
      className={cn(
        'z-50 transition-opacity duration-200',
        // Mobile: relative positioning (no padding since it's in Topbar)
        'relative lg:fixed lg:top-4 lg:left-4',
        // On mobile, always show the button. On desktop, hide when open.
        !isMobile && open ? 'opacity-0 pointer-events-none' : 'opacity-100',
      )}
    >
      <SidebarTrigger className="hover:bg-accent/10 transition-colors duration-200 p-2 lg:bg-background lg:border lg:border-border lg:shadow-md lg:hover:shadow-lg lg:p-3 rounded-md min-h-[36px] min-w-[36px] lg:min-h-[44px] lg:min-w-[44px] flex items-center justify-center">
        <Menu className="h-4 w-4 lg:h-5 lg:w-5 text-foreground" />
        <span className="sr-only">Open menu</span>
      </SidebarTrigger>
    </div>
  );
}
